type AuthEventType = 'unauthorized' | 'logout' | 'login'
type AuthEventListener = () => void

const listeners: Map<AuthEventType, Set<AuthEventListener>> = new Map()

export const authEvents = {
  on: (event: AuthEventType, listener: AuthEventListener) => {
    if (!listeners.has(event)) {
      listeners.set(event, new Set())
    }
    listeners.get(event)!.add(listener)

    return () => {
      listeners.get(event)?.delete(listener)
    }
  },

  emit: (event: AuthEventType) => {
    listeners.get(event)?.forEach((listener) => listener())
  },

  off: (event: AuthEventType, listener: AuthEventListener) => {
    listeners.get(event)?.delete(listener)
  },
}
